<template>
  <b-container>
    <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
    <b-alert
      :show="showDismissibleAlert"
      dismissible
      @dismissed="showDismissibleAlert = false"
      :variant="variant"
    >
     <!-- {{ alertText }} -->
    </b-alert>

    <div>
      <b-row class="justify-content-md-center">
        <b-col md="12" sm="12" class="mt-2">
          <p style="font-size: 17px; color: #2284ab">
            Registration Fees Payment
          </p>
          <p></p>
          <p style="font-size: 0.875rem">
            Registration Fees is to be paid by the Agency.
          </p>

          <div
            style="
              padding: 10px;
              border: 2px solid #c4c6be;
              border-radius: 15px;
            "
            v-if="showdtls"
          >
            <span style="font-size: 0.875rem"
              >Please make online payment, as below, towards registration. </span
            ><br /><br />
            <b-row>
              <b-col md="2" sm="1"></b-col>
              <b-col>
                <b-table
                  show-empty
                  head-variant="dark"
                  stacked="md"
                  bordered
                  striped
                  :items="PendingList"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  style="font-size: 12px"
                >
                </b-table>
              </b-col>

              <b-col md="2" sm="1"></b-col>
            </b-row>

            <b-row>
              <b-col md="7" sm="1"></b-col>
              <b-col style="font-size: 0.875rem"
                ><strong>Total Payment</strong></b-col
              >
              <b-col style="text-align: right; font-size: 0.875rem"
                ><strong>&#8377; {{ total }}</strong></b-col
              >
              <b-col md="2" sm="1"></b-col>
            </b-row>

            <span style="font-size: 0.875rem"
              >Clicking the pay now button will navigate you to a secure payment
              site. On successful transaction you will be redirected back to the
              'Security Guards Board' site.
            </span>
            <p style="font-size: 1rem; color: red">
              *Payment Gateway Charges will be additional and as applicable.
            </p>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-2 justify-content-md-center">
        <b-col style="text-align: right">
          <!-- <b-button type="submit" small variant="primary">Make Payment</b-button> -->
          <!-- <b-button type="reset" small variant="danger">Reset</b-button> -->
          <b-form
            method="POST"
            action="https://pgi.billdesk.com/pgidsk/PGIMerchantPayment"
          >
            <input type="hidden" name="msg" :value="payLoad" />
            <b-button type="submit" variant="primary" v-if="showdtls"
              >Submit</b-button
            >
          </b-form>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import * as _ from "lodash";

export default {
  props:["applicationId"],
  components: { Spinner },
  data() {
    return {
      fields: [
        { key: "type", label: "Name", sortable: true },
        { key: "Count", label: "Count", sortable: true,thClass: 'text-right',tdClass: 'text-right' },
        { key: "total", label: "Fees Amount (including taxes*)", sortable: true,thClass: 'text-right',tdClass: 'text-right',thStyle: { width: "30%" }, },
      ],
      PendingList: [],
      currentPage: 1,
      perPage: 200,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      msg: "",
      fees: 0.0,
      securityID: "",
      token: "",
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      showdtls: false,
      total: 0,
      gst: 0,
      payLoad: "",
      payment: {
        PaymentID: "",
        EventID: "",
        BoardID: "",
        UserID: "",
        TransactionStatus: "Pending",
        TransactionType: "Exempted Agency Registration",
        TransactionAmount: 0,
        TransactionCharges: 0,
        Currency: "INR",
        MerchantID: "",
        PaymentStatus: false,
        UserName: "",
        Purpose: "Registration U/S 23",
      },
    };
  },
  methods: {
    CalculateFees() {
      var userinfo = this.$store.getters.loggedUser; 
      var userid = userinfo.UserId;
      // var payloadex = {
      //   "AgencyID" :userid,
      //   "ApplicationID" : this.applicationId
      // }
      let promise = apis.ReadCalculate_Exemption_PaymentFee(userid , this.applicationId);

      promise
        .then((response) => {
          // console.log(response);
          if (response.status == 200) {
            this.PendingList = response.body;

            let q = _.filter(this.PendingList, {
              type: "total",
              AgencyID: null
            });
            if (q) {
              this.total = q[0].total;
            }


            //remove total record from json
            var list_pending=this.PendingList;
            for(var i = 0; i<list_pending.length; i++)
            {
              if(list_pending[i].type == "total")
              {
                list_pending.splice(i, 1);
              }
            }
            this.PendingList=list_pending;
            // alert(this.total);
            let pmtobj = this.$store.getters.getPmtObj;
            this.payment.BoardID = pmtobj.BoardID;
            this.payment.EventID = this.PendingList[0].AgencyID;
            this.payment.UserID = userinfo.UserId;
            this.payment.TransactionAmount = this.total;
            this.payment.UserName = userinfo.UserName;
            let promise2 = apis.getPmtRequest(this.payment);

            promise2
              .then((response) => {
                // console.log(response);
                if (response.status == 200) {
                  localStorage.setItem("userinfo", JSON.stringify(userinfo));
                  localStorage.setItem("token", response.body.token);

                  //console.log(response.body.token);
                  this.payLoad = response.body.msg;
                  this.$store.dispatch("setPrintPmt", false);
                  // console.log("Payload", this.payLoad);
                  this.showdtls = true;
                } else {
                  this.alertText = response.body;
                  this.variant = "warning";
                  this.showDismissibleAlert = true;
                }
              })
              .catch((err) => {
                this.alertText = err.body;
                this.showDismissibleAlert = true;
                this.variant = "danger";
              });

            this.isLoading = false;
          } else {
            this.alertText =
              "Error in calculating the Fees amount. Please try again after some time.";

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch((err) => {
          this.alertText =
            "Error in calculating the Fees amount. Please try again after some time.";
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
  },
  mounted() {
    this.isLoading = true;
    this.CalculateFees();
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/AgencyExemption/RegistrationFeesPmt.vue